'use strict';

const BaseScene = require('./base-scene');
const Button = require('../ui/button');
const { COLORS, GAME_WIDTH } = require('../config/constants');
const { drawGlowText, drawText, drawPanel } = require('../ui/draw');

const TYPES = [
  { key: 'DAILY', label: '今日' },
  { key: 'WEEKLY', label: '本周' },
  { key: 'ALL_TIME', label: '总榜' }
];
const PAGE_SIZE = 8;

class LeaderboardScene extends BaseScene {
  enter(payload) {
    this.type = (payload && payload.type) || 'DAILY';
    this.page = 0;
    this.data = this.app.leaderboard && this.app.leaderboard.type === this.type
      ? this.app.leaderboard : null;
    this.loading = false;
    this.error = '';
    this.buildButtons();
    this.load();
  }

  load() {
    this.loading = true;
    this.error = '';
    this.app.refreshLeaderboard(this.type).then((data) => {
      this.data = data; this.page = 0; this.loading = false; this.buildButtons();
    }).catch(() => {
      this.loading = false; this.error = '加载失败，当前显示缓存榜单';
    });
  }

  selectType(type) {
    if (type === this.type) return;
    this.type = type; this.data = null; this.page = 0; this.buildButtons(); this.load();
  }

  buildButtons() {
    this.buttons = TYPES.map((item, index) => new Button({
      x: 58 + index * 218, y: 175, width: 198, height: 70, label: item.label,
      variant: item.key === this.type ? 'primary' : 'secondary', fontSize: 26,
      onTap: () => this.selectType(item.key)
    }));
    this.buttons.push(
      new Button({ x: 55, y: 1168, width: 180, height: 78, label: '上一页', variant: 'secondary', disabled: this.page <= 0, onTap: () => { this.page -= 1; this.buildButtons(); } }),
      new Button({ x: 285, y: 1168, width: 180, height: 78, label: '返回', variant: 'secondary', onTap: () => this.app.switchScene('home') }),
      new Button({ x: 515, y: 1168, width: 180, height: 78, label: '下一页', variant: 'secondary', disabled: !this.data || (this.page + 1) * PAGE_SIZE >= this.data.items.length, onTap: () => { this.page += 1; this.buildButtons(); } })
    );
  }

  render(ctx) {
    drawGlowText(ctx, '飞行排行榜', GAME_WIDTH / 2, 100, 54, COLORS.cyan);
    this.drawButtons(ctx);
    const items = (this.data && this.data.items) || [];
    const visible = items.slice(this.page * PAGE_SIZE, (this.page + 1) * PAGE_SIZE);
    if (!visible.length) drawText(ctx, this.loading ? '正在加载榜单…' : '暂无排名', GAME_WIDTH / 2, 570, 28, COLORS.muted);
    visible.forEach((item, index) => {
      const y = 280 + index * 100;
      const mine = String(item.userId) === String(this.app.user.id);
      drawPanel(ctx, 45, y, 660, 78, { radius: 16, fill: mine ? 'rgba(70,230,255,.15)' : 'rgba(8,24,58,.78)', stroke: mine ? COLORS.cyan : 'rgba(145,164,201,.18)' });
      drawText(ctx, `#${item.rank}`, 75, y + 39, 25, item.rank <= 3 ? '#ffd45d' : COLORS.muted, 'left', 'bold');
      drawText(ctx, item.username, 170, y + 39, 25, mine ? COLORS.cyan : COLORS.text, 'left', mine ? 'bold' : 'normal');
      drawText(ctx, `${item.score} 分`, 520, y + 28, 24, COLORS.success, 'right', 'bold');
      drawText(ctx, `第 ${item.level} 关`, 650, y + 50, 19, COLORS.muted, 'right');
    });
    if (this.data) drawText(ctx, `${this.page + 1} / ${Math.max(1, Math.ceil(items.length / PAGE_SIZE))}`, GAME_WIDTH / 2, 1118, 22, COLORS.muted);
    if (this.error) drawText(ctx, this.error, GAME_WIDTH / 2, 1080, 21, COLORS.warning);
  }
}

module.exports = LeaderboardScene;
